import styled from "@emotion/styled";

import { FormField } from "@livechat/design-system-react-components";

export const FormFieldNoMargin = styled(FormField)`
  margin: 0;
`;
